export default {"src":"/_next/static/media/CosmeticConcerns.87fbd8b0.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};